import React, { ReactNode } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Cross2Icon } from "@radix-ui/react-icons";
import { ThemedIconButton, ThemedPrimaryButton } from "../Button/Button";
import "./Modal.css";

type ModalTypes = {
  title: string;
  buttonContent?: string | ReactNode;
  description: string;
  content: (handleClose: () => void) => ReactNode;
  fullpage?: boolean;
};

const Modal = ({
  title,
  buttonContent,
  description,
  content,
  fullpage,
}: ModalTypes) => {
  const [open, setOpen] = React.useState(false);
  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>
        <ThemedPrimaryButton>{buttonContent}</ThemedPrimaryButton>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="DialogOverlay" />
        <Dialog.Content
          className={`${fullpage ? "fullpage" : ""} DialogContent `}
        >
          <Dialog.Title className="DialogTitle">{title}</Dialog.Title>
          <Dialog.Description className="DialogDescription">
            {description}
          </Dialog.Description>
          {content(() => setOpen(false))}
          <div
            style={{
              display: "flex",
              marginTop: 25,
              justifyContent: "flex-end",
            }}
          ></div>
          <Dialog.Close asChild>
            <ThemedIconButton className="closeIcon" aria-label="Close">
              <Cross2Icon />
            </ThemedIconButton>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default Modal;
